import { Controller } from "@hotwired/stimulus"

// Vista previa del PDF de la orden de compra con lo que hay cargado en el
// formulario, sin guardar nada: manda los campos al endpoint preview_pdf y
// muestra el PDF que vuelve dentro del modal.
export default class extends Controller {
  static targets = ["modal", "frame", "spinner", "error", "button"]
  static values = { url: String }

  open() {
    const form = this.element.querySelector("form")
    if (!form) return

    this.showModal()
    this.spinnerTarget.classList.remove("d-none")
    this.frameTarget.classList.add("d-none")
    this.errorTarget.classList.add("d-none")
    this.revokeUrl()

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": csrfToken },
      body: new FormData(form)
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.blob()
      })
      .then((blob) => {
        this.objectUrl = URL.createObjectURL(blob)
        this.frameTarget.src = this.objectUrl
        this.spinnerTarget.classList.add("d-none")
        this.frameTarget.classList.remove("d-none")
      })
      .catch(() => {
        this.spinnerTarget.classList.add("d-none")
        this.errorTarget.textContent =
          "No se pudo generar la vista previa. Revisá que la orden tenga fecha, al menos un SKU con cantidad y precio."
        this.errorTarget.classList.remove("d-none")
      })
  }

  showModal() {
    // Bootstrap 4 vía jQuery, como el resto de los modales de la app.
    if (window.jQuery) {
      window.jQuery(this.modalTarget).modal("show")
    } else {
      this.modalTarget.classList.add("show")
      this.modalTarget.style.display = "block"
    }
  }

  revokeUrl() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl)
      this.objectUrl = null
    }
  }

  disconnect() {
    this.revokeUrl()
  }
}
